<template>
  <div :class="$style.container">
    <payment-template>
      <base-header
        slot="header"
        :title="$t('payment.denied.title')"
        :language="getLanguage"
      />
      <base-card-template slot="content">
        <img
          slot="image"
          src="@/assets/images/snail-cabbage.gif"
          :class="$style.image"
          alt="snail"
        />
        <p>{{ $t('payment.denied.message') }}</p>
        <simple-button variant="secondary" @click="handleRedirect">
          {{ $t('try.again') }}
        </simple-button>
      </base-card-template>
    </payment-template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SimpleButton from 'molecules/common/SimpleButton';
import BaseHeader from 'organisms/base/BaseHeader';
import BaseCardTemplate from 'templates/BaseCardTemplate';
import PaymentTemplate from 'templates/PaymentTemplate';

export default {
  name: 'FailedPayment',
  components: {
    SimpleButton,
    BaseHeader,
    BaseCardTemplate,
    PaymentTemplate,
  },
  computed: {
    ...mapGetters(['getLanguage', 'getRouteWithParamsByTransaction']),
  },
  methods: {
    handleRedirect() {
      this.$router.push(this.getRouteWithParamsByTransaction);
    },
  },
};
</script>

<style lang="sass" module>
  .container
    +respond-to('medium')
      padding: 10px 0

  .image
    max-width: 127px
    max-height: 117px
</style>
